import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import ShopItem from "./ShopItem/ShopItem";

const dateSort = (rowA, rowB) => {
  const dateA = rowA.createdAt ? new Date(rowA.createdAt).getTime() : 0;
  const dateB = rowB.createdAt ? new Date(rowB.createdAt).getTime() : 0;
  return dateA - dateB;
};

const columns = [
  {
    name: "Reference",
    selector: "paymentReference",
    sortable: true,
    style: { fontSize: "14px", fontWeight: "600" },
  },
  {
    name: "Date",
    selector: "createdAt",
    sortable: true,
    sortFunction: dateSort,
    style: { fontSize: "14px" },
    format: (row) => {
      if (!row.createdAt) return "N/A";
      const date = new Date(row.createdAt);
      return date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
  {
    name: "Organization",
    selector: "organizationName",
    sortable: true,
    style: { fontSize: "14px" },
  },
  {
    name: "Customer",
    selector: "userEmail",
    sortable: true,
    style: { fontSize: "14px" },
  },
  {
    name: "Items",
    selector: "items",
    sortable: false,
    style: { fontSize: "14px" },
    format: (row) => (row.items ? row.items.length : 0),
  },
  {
    name: "Total",
    selector: "totalAmount",
    sortable: true,
    style: { fontSize: "14px", fontWeight: "600" },
    format: (row) => (row.totalAmount != null ? `€${row.totalAmount}` : "N/A"),
  },
  {
    name: "Status",
    selector: "status",
    sortable: true,
    style: { fontSize: "14px" },
    cell: (row) => {
      const s = row.status || "unknown";
      let color = "#888";
      if (s === "pending") color = "#e5920a";
      if (s === "confirmed") color = "#16a34a";
      if (s === "cancelled") color = "#e03e3e";
      return <span style={{ color, fontWeight: 600, textTransform: "capitalize" }}>{s}</span>;
    },
  },
];

class Shop extends Component {
  state = {
    orders: [],
    selectedOrder: null,
    dataChanged: false,
  };

  loadOrders = () => {
    axios
      .get("/shop-orders")
      .then((response) => {
        if (response.data) {
          this.setState({ orders: response.data });
        }
      })
      .catch((err) => {
        console.error("Failed to load orders:", err);
      });
  };

  componentDidMount() {
    this.loadOrders();
  }

  componentDidUpdate() {
    if (this.state.dataChanged) {
      this.loadOrders();
      this.setState({ dataChanged: false });
    }
  }

  render() {
    return (
      <ContentContainer title="Shop Orders">
        <DataTable
          columns={columns}
          data={this.state.orders}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"createdAt"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" } },
          }}
          onRowClicked={(order) => this.setState({ selectedOrder: order })}
        />

        {this.state.selectedOrder && (
          <ShopItem
            order={this.state.selectedOrder}
            onClose={() => {
              this.setState({ selectedOrder: null });
              this.loadOrders();
            }}
            dataChanged={() => this.setState({ dataChanged: true })}
          />
        )}
      </ContentContainer>
    );
  }
}

export default Shop;
